import { Component, Input } from '@angular/core';

@Component({
  selector: 'simple-spinner',
  template: `
    <div class="simple-spinner" [ngStyle]="{'width.px': size, 'height.px': size}">
      <div class="double-bounce1"></div>
      <div class="double-bounce2"></div>
    </div>
  `,
  styleUrls: ['./simple-spinner.component.scss']
})
export class SimpleSpinnerComponent {
  @Input() size = 40;
} 